/**
 * Unit conversion between millimetres, inches, printer dots and screen pixels.
 *
 * Ported from ns-web resources/js/components/common/label-viewer/utils/unit-converter.js
 * Changes: designer-only helpers (display units, clamping, DPI snapping for
 * select menus) dropped; dots ↔ px helpers added for the preview component.
 */

/** CSS reference resolution: 1 CSS px = 1/96 inch. */
export const SCREEN_DPI = 96;

/** Print resolutions Phoenix templates are stored at. */
export const SUPPORTED_DPI = [203, 300] as const;

export function mmToDots(mm: number, dpi: number): number {
  return Math.round((mm * dpi) / 25.4);
}

export function dotsToMm(dots: number, dpi: number): number {
  return (dots * 25.4) / dpi;
}

export function inchesToDots(inches: number, dpi: number): number {
  return Math.round(inches * dpi);
}

export function dotsToInches(dots: number, dpi: number): number {
  return dots / dpi;
}

/**
 * Screen pixels per printer dot. zoom = 1 shows the label at its physical size
 * on a 96-dpi CSS display.
 */
export function pxPerDot(dpi: number, zoom = 1): number {
  return (SCREEN_DPI / dpi) * zoom;
}

export function dotsToPx(dots: number, dpi: number, zoom = 1): number {
  return dots * pxPerDot(dpi, zoom);
}

export function pxToDots(px: number, dpi: number, zoom = 1): number {
  return px / pxPerDot(dpi, zoom);
}
